import AppRoutes from "./Components/AppRoutes/AppRoutes";
import "./App.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "bootstrap/dist/css/bootstrap.min.css";
// Import custom CSS AFTER Bootstrap so it can override Bootstrap styles
import "../src/Components/Modules/BulkEdit/BulkEditStyle.css";
import React, { useEffect } from "react";

export default function App() {
  useEffect(() => {
    console.log("✅ BASE URL =>", process.env.REACT_APP_API_BASEURL);
    console.log("✅ ENDPOINT =>", process.env.REACT_APP_API_ENDPOINT);
  }, []);

  return (
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  );
}
